import { FeatureFlags } from 'types';

type ContractorText = {
  contractor: string;
  contractors: string;
  contractorsTitleCase: string;
  contractorTitleCase: string;
};

export const isContractorsPanValidationEnabled = ({
  isRxCurrentAccountMerchant,
  featureFlags,
}: {
  isRxCurrentAccountMerchant: boolean | undefined;
  featureFlags: Record<FeatureFlags, boolean> | null;
}) => {
  if (!featureFlags) return false;

  const isContactorsPanValidationEnabled = featureFlags.enableContractorsPanValidation;
  const skipContractorPanValidationForSpecificOrgs =
    featureFlags.skipContractorPanValidationForSpecificOrgs;

  if (skipContractorPanValidationForSpecificOrgs) return false;

  return !isRxCurrentAccountMerchant && isContactorsPanValidationEnabled;
};

export const getContractorText = (data: {
  isRxCurrentAccountMerchant: boolean | undefined;
  featureFlags: Record<FeatureFlags, boolean> | null;
}): ContractorText => {
  const shouldShowPartTimeEmployeeText = isContractorsPanValidationEnabled(data);

  if (shouldShowPartTimeEmployeeText) {
    return {
      contractor: 'part-time employee',
      contractors: 'part-time employees',
      contractorsTitleCase: 'Part-Time Employees',
      contractorTitleCase: 'Part-Time Employee',
    };
  }

  return {
    contractor: 'contractor',
    contractors: 'contractors',
    contractorsTitleCase: 'Contractors',
    contractorTitleCase: 'Contractor',
  };
};
